import { CSSProperties } from 'react';
import { Image } from './image-gallery.types'

export const colors = Object.freeze({
    white: 'white',
    blue: '#3aabf2',
    light_blue: '#57b8f4',
    orange: '#f26522',
    light_orange: '#f3763a',
    black: 'black',
    grey: '#575757',
    dark_grey: '#797979',
    gold: '#c9c124',
    green: 'green',
    light_gray: 'lightgray',
    red: 'red',
    light_green: 'rgba(11, 102, 35, 0.75)',
    transparent: 'transparent',
    yellow: 'yellow',
    background_opacity: '#ffffff0d',
    dark_background_opacity: '#403f3fa1',
    background_header: '#171717',
    text_grey: '#BFBFBF'
});

const PORTRAIT_ASPECT_RATIO = 0.7;

export const getPortraitHeightByWidth = (width: number) => {
    return width / PORTRAIT_ASPECT_RATIO;
};

export const getPortraitWidthByHeight = (height: number) => {
    return height * PORTRAIT_ASPECT_RATIO;
};

export const ImageTypes = {
    SQUARE: 'square' as 'square',
    PORTRAIT: 'portrait' as 'portrait'
};

export const getImageDefault = (images, type: any) => {
    if (!images) return null;
    if (!images.length) return images;
    return (images.find((img: Image) => {
      if (img[type] || (img[`${type}Width`] || img[`${type}X`] || img[`${type}Y`])) {
        return img;
      }
    })) || images[0];
  };

export const setImageStyles = (
    entryImg: { width: number, height: number },
    images: Image | Image[],
    type: typeof ImageTypes
  ): CSSProperties => {
    const image = getImageDefault(images, type);
  
    if (!image) return undefined;
  
    const scaleWidth = entryImg.width * image[`${type}Width`];
    const leftOffset = image[`${type}X`] / 100 * scaleWidth;
    const scaleHeight = scaleWidth * (image.originalHeight / image.originalWidth);
    const topOffset = image[`${type}Y`] / 100 * scaleHeight;
  
    const imageUrl = encodeURI(image.url || '').replace(/["'()]/g, '\\$&');

    const background =
      `url("${imageUrl}") ${-leftOffset}px ${-topOffset}px / ${scaleWidth}px ${scaleHeight}px no-repeat ${colors.white}`;
  
    return {
      background,
      ...entryImg,
      borderRadius: 14
    };
  };

export const getContainerSize = (maxWidth?: number, maxHeight?: number): CSSProperties => {
  const bottomSliderHeight = 145;

  let width;
  let height;

  switch (true) {
    case Boolean(maxWidth && maxHeight): {
      const totalHeight = getPortraitHeightByWidth(maxWidth) + bottomSliderHeight;
      if (totalHeight <= maxHeight) {
        width = maxWidth;
        height = totalHeight;
      }
      break;
    }
    case Boolean(maxWidth): {
      const totalHeight = getPortraitHeightByWidth(maxWidth) + bottomSliderHeight;
      width = maxWidth;
      height = totalHeight;
      break;
    }
    case Boolean(maxHeight): {
      height = maxHeight;
      width = getPortraitWidthByHeight(height - bottomSliderHeight);
      break;
    }
    default: break;
  }

  return { width, height };
};